import { Button } from '../../../components/Button/Button'
import { ReactComponent as ZocksIcon } from '../../../assets/ZocksIcon.svg'
import { useNavigate } from 'react-router-dom'

type BackTarget = 'integration' | 'app'

type IntegrationManagementHeaderProps = {
  backTarget: BackTarget
}

export const IntegrationManagementHeader = ({ backTarget }: IntegrationManagementHeaderProps) => {
  const navigate = useNavigate()

  const handleBackButtonClicked = () => {
    const pathMap: Record<BackTarget, string> = {
      integration: '/account/integration-settings/integrations',
      app: '/account/integration-settings/oauth2apps',
    }

    navigate({
      pathname: pathMap[backTarget],
    })
  }

  return (
    <div className='d-flex flex-column'>
      <div className='d-flex zocks-pl-2.0 justify-content-between align-items-center'>
        <div className='d-flex align-items-center zocks-gap-2'>
          <div className='d-lg-none'>
            <ZocksIcon />
          </div>
          <div className='d-none align-items-center d-sm-flex zocks-gap-1.25'>
            <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
              <i className='bi bi-chevron-left' />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
